<template>
  <img :src="moveImagePath" :v-snow="isShowMoveImage" id="move-image">
</template>
<script>
export default {
  name: 'SelectStyleImageMove',
  props: {
    'url': String,
    'image_ref': String
  },
  data () {
    return {
      moveImagePath: null,
      isShowMoveImage: false
    }
  },
  methods: {
    move (imagePath, pyFrom, pxFrom, pyTo, pxTo, width, height) {
      this.moveImagePath = imagePath
      this.isShowMoveImage = true
      let moveImage = document.getElementById('move-image')
      moveImage.style.position = 'absolute'
      moveImage.style.top = pyFrom + 'px'
      moveImage.style.left = pxFrom + 'px'
      moveImage.style.width = width + 'px'
      moveImage.style.height = height + 'px'
      moveImage.style.transform = 'translate(' + (pxTo - pxFrom) + 'px, ' + (pyTo - pyFrom) + 'px) scale(0.6, 0.6)'
      moveImage.style.transitionDuration = '0.5s'
      moveImage.style.opacity = '0.7'
    },
    restore () {
      this.moveImagePath = null
      this.isShowMoveImage = false
      let moveImage = document.getElementById('move-image')
      moveImage.style = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SelectStyleImageMove.vue